import { useQuery } from '@tanstack/react-query';
import {
    fetchServiceOrderExecutiveDashboard,
    fetchServiceOrderSummary,
    fetchServiceOrderRiskAlerts,
    fetchServiceOrdersByStatus,
    fetchServiceOrdersByProject,
    fetchServiceOrderMonthly,
    fetchServiceOrderPendingValuation,
    fetchServiceOrdersDetailByStatus,
} from '../../api/report/serviceOrderReportApi';

const cleanParams = (params = {}) => {
    return Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
    );
};

export const useServiceOrderExecutiveDashboard = (params = {}) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'executive-dashboard', safeParams],
        queryFn: () => fetchServiceOrderExecutiveDashboard(safeParams),
        staleTime: 1000 * 60 * 5,
        keepPreviousData: true,
    });
};

export const useServiceOrderSummary = (params = {}) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'summary', safeParams],
        queryFn: () => fetchServiceOrderSummary(safeParams),
        staleTime: 1000 * 60 * 5,
    });
};

export const useServiceOrderRiskAlerts = (params = {}) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'risk-alerts', safeParams],
        queryFn: () => fetchServiceOrderRiskAlerts(safeParams),
        staleTime: 1000 * 60 * 3,
    });
};

export const useServiceOrdersByStatus = (params = {}) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'by-status', safeParams],
        queryFn: () => fetchServiceOrdersByStatus(safeParams),
        staleTime: 1000 * 60 * 5,
    });
};

export const useServiceOrdersByProject = (params = {}) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'by-project', safeParams],
        queryFn: () => fetchServiceOrdersByProject(safeParams),
        staleTime: 1000 * 60 * 5,
    });
};

export const useServiceOrderMonthly = (params = {}) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'monthly', safeParams],
        queryFn: () => fetchServiceOrderMonthly(safeParams),
        staleTime: 1000 * 60 * 5,
    });
};

export const useServiceOrderPendingValuation = (params = {}) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'pending-valuation', safeParams],
        queryFn: () => fetchServiceOrderPendingValuation(safeParams),
        staleTime: 1000 * 60 * 5,
    });
};

export const useServiceOrdersDetailByStatus = (status, params = {}, enabled = false) => {
    const safeParams = cleanParams(params);

    return useQuery({
        queryKey: ['service-order-report', 'detail-by-status', status, safeParams],
        queryFn: () => fetchServiceOrdersDetailByStatus(status, safeParams),
        enabled: Boolean(status) && enabled,
        staleTime: 1000 * 60 * 3,
    });
};